import router from './router.js'

router.beforeEach(async(to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next()

})
